var base = require('settings/teams/current-teams');

Vue.component('spark-current-teams', {
    mixins: [base],

    data: function(){
        return {
            leave_modal: false,
            delete_modal: false,
            headers: [{
                value: 'photo_url',  align: 'left', sortable: false
            },{
                text: 'Name', value: 'name',  align: 'left'
            },{
                text: 'Owner', value: 'owner',  align: 'left'
            },{
                value: 'edit', sortable: false
            },{
                value: 'leave', sortable: false
            },{
                value: 'delete', sortable: false
            }]
        };
    },

    methods: {

        /**
         * Approve leaving the given team.
         */
        approveLeavingTeam : function(team) {
            this.leavingTeam = team;

            //$('#modal-leave-team').modal('show');
            this.leave_modal = true;
        },

        /**
         * Leave the given team.
         */
        leaveTeam : function() {
            var self = this;
            Spark.delete(this.urlForLeaving, this.leaveTeamForm)
                .then(() => {
                    Bus.$emit('updateUser');
                    Bus.$emit('updateTeams');

                    //$('#modal-leave-team').modal('hide');
                    self.leave_modal = false
                });
        },


        /**
         * Approve the deletion of the given team.
         */
        approveTeamDelete : function(team) {
            this.deletingTeam = team;

            //$('#modal-delete-team').modal('show');
            this.delete_modal = true;
        },


        /**
         * Delete the given team.
         */
        deleteTeam : function() {
            var self = this;
            Spark.delete(`/settings/${Spark.teamsPrefix}/${this.deletingTeam.id}`, this.deleteTeamForm)
                .then(() => {
                    Bus.$emit('updateUser');
                    Bus.$emit('updateTeams');

                    //$('#modal-delete-team').modal('hide');
                    self.delete_modal = false;
                });
        }
    }
});
